import { render, staticRenderFns } from "./EditVisibility.vue?vue&type=template&id=e87a8d18&scoped=true&"
import script from "./EditVisibility.vue?vue&type=script&lang=js&"
export * from "./EditVisibility.vue?vue&type=script&lang=js&"
import style0 from "./EditVisibility.vue?vue&type=style&index=0&id=e87a8d18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87a8d18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCheckbox,VSheet})
